import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import Modal from '@cloudscape-design/components/modal';
import SpaceBetween from '@cloudscape-design/components/space-between';

type DeleteProps = {
  visible: boolean;
  onDiscard: () => void;
  onDelete: () => void;
  selectedItems: any;
};

export default function Delete({
  visible,
  onDiscard,
  onDelete,
  selectedItems,
}: DeleteProps) {
  return (
    <Modal
      visible={visible}
      onDismiss={onDiscard}
      header={'Eintrag löschen'}
      closeAriaLabel="Close dialog"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDiscard}>
              Abbrechen
            </Button>
            <Button variant="primary" formAction="submit" onClick={onDelete}>
              Löschen
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      {selectedItems.length > 0 && (
        <SpaceBetween size="m">
          <Box variant="span">
            Eintrag{' '}
            <Box variant="span" fontWeight="bold">
              {selectedItems.length > 0 ? selectedItems[0].name : ''}
            </Box>{' '}
            dauerhaft löschen? Sie können diese Aktion nicht rückgängig machen.
          </Box>

          <Alert statusIconAriaLabel="Info">
            Wenn Sie diese Aktion ausführen, wird der Eintrag und der
            dazugehörige Inhalt gelöscht und kann sich auf zugehörige Ressourcen
            auswirken.
          </Alert>
        </SpaceBetween>
      )}
    </Modal>
  );
}
